module.exports = __webpack_public_path__ + "img/wave-arrow.8dfed73f.svg";